import React from 'react'
import { formatString } from '@cbgms/base/utils/helpers'

export interface IFullShopProps {
  shopID: string
  shopName: string
  shopCity?: string
}

const FullShop: React.FC<IFullShopProps> = props => <React.Fragment>{formatString(props.shopName, props.shopCity)}</React.Fragment>

export default FullShop
